import debounce from "lodash.debounce"; // 防抖函数
String.prototype.splice = function (start, newStr) {
  return this.slice(0, start) + newStr + this.slice(start);
};
export default {
  beforeRouteEnter(to, from, next) {
    if (window.innerWidth > 1366) {
      document.body.style.zoom = 1;
    } else {
      document.body.style.zoom = 0.9;
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (window.innerWidth > 1366) {
      document.body.style.zoom = 1;
    } else {
      document.body.style.zoom = 0.8;
    }
    next();
  },
  data() {
    return {
      bCb: false,
      editorDe: "#cfe8cc", // 编辑器完成的样式
      editorOff: "#454545", // 编辑器不可编辑的样式
      editorNo: "", // 编辑器可编辑的样式
      focusBack: "", // 编辑器正在编辑的样式
      insertColor: "#555", // 新增文本字体颜色
      itermColor: "", // 术语背景颜色
      placeholder: true,
      termSubmit: false,
      ifSubmit: true,
      sentenceShow: false,
      isLock: false,
      typeShow: true,
      isBack: true, // 用户回退到那个界面
      addPostil: require("../../../assets/imgs/editor/sm_pz.png"),
      Postil: require("../../../assets/imgs/editor/sm_pz.png"),
      postilTarget: {},
      isAddPostil: false,
      isUpdatePostil: false,
      updatePostilTxt: "",
      postilId: "",
      postilList: [],
      isSourceEd: false,
      isEditR: false, // 右键判断是否可编辑
      dialogVisible: false,
      myInnerText: "",
      contrastDebounce: "",
      startOffset: "",
      isEditorSentHighlight: false,
      isUpdatePostilBut: true,
      isSplit: '',
      actList: [],
      isRecord: true,
      isPreMt: true,
      updateHtmlIdList: [],
      QACurrent: 0,
      contentEditableValue: 'plaintext-only',
      userInfo: {
        id: -1
      },
      interpreteruid: ""
    };
  },
  watch: {
    inputTxt: function () {
      if (this.isSeekBox === 2) {
        this.debounce();
      }
    },
    isSeekBox: function (newV, oldV) {
      if (oldV == '1') {
        // this.seekShow();
        this.seekIndex = 0;
        this.seekNum = 0;
        this.seekNum2 = 0;
        this.seekTxt = "";
        this.seekTxt2 = "";
        this.actList = [];
        this.delClassList();
        [...new Set(this.updateHtmlIdList)].forEach(item =>
          this.getSentHtmlContent(item)
        ); //
        this.updateHtmlIdList = [];
      }
    },
    // isFind: function () {
    //   let that = this;
    //   if (this.isFind) {
    //     this.seekChange();
    //   } else {
    // this.seekShow();
    // this.delClassList();
    // [...new Set(this.updateHtmlIdList)].forEach(item =>
    //   that.getSentHtmlContent(item)
    // ); //
    // this.updateHtmlIdList = [];

    //   }
    // }
  },
  created() {
    // if (sessionStorage.getItem("isRecord")) {
    //   this.isRecord = sessionStorage.getItem("isRecord")=='true' ? true : false;
    // }
    this.checkBrowser();
    if (sessionStorage.sessionBCb === "true") {
      // 夜间模式
      this.bCb = true;
      this.editorDe = "#50606e"; //确定块的颜色
      this.editorOff = "#696A6D";
      this.editorNo = "#AAABAD";
      this.focusBack = "#405982";
    } else {
      // 日间
      this.bCb = false;
      this.editorDe = "#cfe8cc"; //确定块的
      this.editorOff = "rgb(170,170,170)";
      this.editorNo = "#454545";
      this.focusBack = "#e5f1be";
    }
    this.loadinginstace = this.$loading({
      fullscreen: true,
    });
    let myUser = localStorage.getItem("myUser");
    if (myUser) {
      this.userInfo = JSON.parse(myUser);
    } //把字符串转换成JSON对象
    const lastSelectCompany = JSON.parse(localStorage.lastSelectCompany)
    if (lastSelectCompany.role) {
      this.roleLevel = lastSelectCompany.role.roleLevel;
    } else {
      this.roleLevel = lastSelectCompany.companyUser.roleLevel;
    }
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    this.taskTypeName =
      this.queryData.taskType === 2 ?
      "审校" :
      this.queryData.taskType === 3 ?
      "复审" :
      "翻译";
    this.project = this.queryData.project;
    this.fileSuffix = this.queryData.fileSuffix;
    this.monitorStatus();
    this.getFileInformation();
    if (this.queryData.project === 3) {
      this.checkTaskStatus();
    }
    //判断用户是从哪里跳转过来的。然后给提示语
    if (this.queryData.transStatus == 2) {
      this.isBack = true;
    } else {
      this.isBack = false;
    }
    this.getIsEditorSentHighlight();
    this.debounce = debounce(this.search, 500);
    this.contrastDebounce = debounce(this.sentenceContrast, 200);
    this.getTaskProgress();
  },
  mounted() {
    window.onbeforeunload = function (e) {
      // 监听窗口关闭术语提示
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (
        (event.clientX > document.body.clientWidth && event.clientY < 0) ||
        event.altKey
      ) {
        e.returnValue = "关闭提示";
      }
      return "关闭提示";
    };
    window.addEventListener("keydown", this.shortcutKey, false);
  },
  beforeDestroy() {
    window.onbeforeunload = null;
    window.removeEventListener("keydown", this.shortcutKey);
  },
  methods: {
    // 写作时间
    writingSpeed(isClear){
      if (isClear) {
        this.oldTime = null;
        return
      }
       this.oldTime = new Date();
       console.log(this.oldTime,"this.oldTime");
    },
    // 跳到任务页码
    toTaskIndex(data) {
      console.log(this.endIndex, ">>>>>");
      if (this.endIndex <= 20) {
        if (this.endIndex >= data.startPartIndex) {
          let dom = this.$refs.viewBox2.querySelector(`span[uid='${data.uid}']`);
          if (dom) {
            dom.scrollIntoView()
          }
          
        } else {
          for (let index = this.endIndex; index < data.startPartIndex; index++) {
            this.getWord(index, 1);
            this.num = index;
          }
          let dom = this.$refs.viewBox2.querySelector(`span[uid='${data.uid}']`);
          if (dom) {
            dom.scrollIntoView()
          }
          
        }
      } else {
        if (this.endIndex - 20 < data.startPartIndex && this.endIndex >= data.startPartIndex) {
          let dom = this.$refs.viewBox2.querySelector(`span[uid='${data.uid}']`);
          if (dom) {
            dom.scrollIntoView()
          }
        } else {
          this.sourceList = [];
          this.targetList = [];
          if (data.startPartIndex > 2) {
            this.getWord(data.startPartIndex - 2, 1)
            this.num = data.startPartIndex - 2;
          }else{
            this.getWord(data.startPartIndex, 1)
            this.num = data.startPartIndex;
          }

          let dom = this.$refs.viewBox2.querySelector(`span[uid='${data.uid}']`);
          if (dom) {
            dom.scrollIntoView()
          }
          if (!this.hasScrollbar(this.$refs.viewBox2)) {

          }
        }
      }
    },
    // 判断有无滚动条
    hasScrollbar(dom) {
      return dom.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
    },
    checkBrowser() {
      let userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("firefox") !== -1 || userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1) {
        this.contentEditableValue = "true";
      }
    },
    async rigClick() {
      if (!this.isEditorSentHighlight) {
        return;
      }
      let sentId = this.sid;
      console.log(sentId, "sentId");
      let domList = this.$refs.redactBox.querySelectorAll(`span[sid='${sentId}']`);
      let range = window.getSelection().getRangeAt(0);
      this.startOffset = range.startOffset;
      const lefHighlight = await this.editorSentHighlight({
        fileId: this.queryData.fileId,
        location: range.startOffset,
        modify: domList[1].innerText,
        original: domList[0].innerText,
        sid: sentId,
      })
      const rigHighlight = await this.editorSentHighlight({
        fileId: this.queryData.fileId,
        location: range.startOffset,
        modify: domList[0].innerText,
        original: domList[1].innerText,
        sid: sentId,
      })
      console.log(rigHighlight, lefHighlight, "lefHighlight");
    },
    async editorSentHighlight(params) {
      const res = await this.catReq1Service(
        "/api/v1/file/editorSentHighlight",
        params,
        "post",
        2
      );
      if (res.success) {
        const data = res.result.highlight;
        return data
      }
    },
    async disposeUpdate(event, canIdList = this.canIdList, updateHtml) {
      if (this.rigTagIntext === event.innerText) {
        return
      }
      let timeOut = 0;
      await this.changeText(event, canIdList = this.canIdList, updateHtml,timeOut)
    },
    // 文件详情
    async getFileInformation() {
      let params = {
        id: this.queryData.fileId,
      };
      const response = await this.catReq1Service("/api/v1/file/get", params);
      if (!response.success) {
        return;
      }
      this.isPreMt = response.result.isPreMt;
      this.sourceLangDirection = response.result.sourceLangDirection; // 编写方向:  1.从左到右由上至下横版输入 2.从右到左由上至下横版输入 3.从上到下由左至右竖版输入
      this.targetLangDirection = response.result.targetLangDirection;
      if (!this.isPreMt) {
        this.isRecord = false;
      }
    },
    async setRecord() {
      // sessionStorage.setItem("isRecord", 1);
      this.isRecord = !this.isRecord;
      this.sourceList = [];
      this.targetList = [];
      this.cutOff = false;
      this.num = 1;
      await this.queryBySentId()
      this.getWord("1", 1, true);
    },
    // 样式
    setSty(lefTag, rigTag) {
      let taskType = this.queryData.taskType;
      // let sourceAry = lefTag.getElementsByTagName("span");
      // let targetAry = rigTag.getElementsByTagName("span");
      let status = rigTag.getAttribute("status")
      if (((status == 2 && taskType === 1) || (status == 4 && taskType === 2) || (status == 5 && taskType === 3)) &&
        (rigTag.getAttribute("contenteditable") === this.contentEditableValue || rigTag.getAttribute("contenteditable") === "0")) {
        // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
        rigTag.style.background = this.editorDe;
      }
      // sourceAry = Array.from(sourceAry);
      // sourceAry.forEach(item => {
      //   if (item.getAttribute("comment")) {
      //     this.setCanvasSort(item) // 设置批注
      //     item.style.borderBottom = "2px solid #D7952B";
      //   }
      // })
      // targetAry = Array.from(targetAry);
      // targetAry.forEach(item => {
      //   if (item.getAttribute("comment")) {
      //     item.setAttribute("cid", this.setCanvasSort(item))
      //     item.style.borderBottom = "2px solid #D7952B";
      //     // 设置批注
      //   }
      // })
      // this.setTermSty(lefTag) // 设置术语样式
      // this.setTermSty(rigTag) // 设置术语样式
      this.setInsertSty(rigTag) // 设置新增文本样式
    },
    // 获取其中一个句子的在线编辑的html
    async getSentHtmlContent(sentId) {
      if (!this.isRecord) {
        return
      }
      const params = {
        fileId: this.queryData.fileId,
        sentId,
        comparedHighlight: 1,
        showComment: false,
        showTerm: true,
        timestamp: new Date().getTime()
      };
      const res = await this.catReq1Service('/api/v1/file/getSentHtmlContent', params, 'get');
      if (res.resultCode === '1') {
        let domList = this.$refs.redactBox.querySelectorAll(`span[sid='${sentId}']`);
        console.log(domList[0])
        console.log(domList[1])
        domList[0].innerHTML = res.result.convertStr;
        domList[1].innerHTML = res.result.sourceStr;
        this.setSty(domList[0], domList[1])
      }
    },
    // 设置术语样式
    setTermSty(item, t) {
      if (t) {
        // debugger
      }
      let termDom = item.getElementsByClassName("term");
      if (!termDom) {
        return;
      }
      termDom = Array.from(termDom);
      if (termDom.length) {
        termDom.forEach(i => {
          console.log(i, "iii");
          i.style.background = "rgba(224,115,255,0.2)";
          i.style.color = this.itermColor;
        });
      }
    },
    // 设置新增文本样式
    setInsertSty(item, t) {
      let insertDom = item.getElementsByClassName("insert");
      if (!insertDom) {
        return;
      }
      let color = '#4AAAFB';
      t ? color = '#f9d145' : "";
      insertDom = Array.from(insertDom);
      if (insertDom.length) {
        insertDom.forEach(i => {
          i.style.color = color;
          // i.style.background = "#4AAAFB";
        });
      }
    },
    delClassList() {
      let domList = document.getElementsByClassName("seekActive");
      domList = Array.from(domList);
      let len = domList.length;
      if (len > 0) {
        for (let i = len - 1; i > -1; i--) {
          if (i >= 0) {
            domList[i].classList.remove("seekActive");
          }
        }
      }
      let domList2 = document.getElementsByClassName("current-box");
      domList2 = Array.from(domList2);
      let len2 = domList2.length;
      if (len2 > 0) {
        for (let i = len2 - 1; i > -1; i--) {
          if (i >= 0) {
            domList2[i].classList.remove("current-box");
          }
        }
      }
    },
    async getIsEditorSentHighlight() {
      const {
        result,
        success
      } = await this.catReq1Service(
        "/api/v1/file/isEditorSentHighlight", {
          id: this.queryData.fileId,
        }
      );
      if (success) {
        this.isEditorSentHighlight = result;
      }
    },
    async goQA(row) {
      let ret;
      const startSectionIndex = this.targetList[0].startSectionIndex;
      const endSectionIndex = this.targetList[this.targetList.length - 1]
        .endSectionIndex;
      if (row.sectionIndex < startSectionIndex && startSectionIndex != 0) {
        this.cutOff = false;
        let page = "";
        page = this.num - 20;
        this.num--;
        await this.getWord(page, 2);
        this.goQA(row);
      } else if (row.sectionIndex > endSectionIndex && endSectionIndex != 0) {
        this.num++;
        await this.getWord(this.num, 1);
        this.goQA(row);
      } else {
        const dom = await this.domFun(row);
        dom.scrollIntoView();
        dom.focus();
      }
    },
    // 修改原文
    async updateSource(event) {
      let sentId = Number(event.getAttribute("sId"));
      let status = Number(event.getAttribute("status"));
      let taskType = this.queryData.taskType;
      let params = {
        sentId: sentId,
        fileId: this.queryData.fileId,
        content: event.innerText,
        taskType: taskType,
        status,
        taskId: this.queryData.taskId
      };
      const {
        success
      } = await this.catReq1Service(
        "/api/v1/file/updateFileSourceSent ",
        params
      );
      if (success) {
        this.$message.closeAll();
        this.$message({
          message: "修改原文成功",
          type: "success",
        });
        return;
      }
    },
    // 关闭编辑原文
    outSourceEditor() {
      const that = this;
      this.isSourceEd = false;
      this.sourceEditorLefTag.style.border = "0px";
      this.sourceEditorLefTag.oninput = function ($event) {
        $event.target.innerText = that.myInnerText;
      };
      this.sourceEditorLefTag.onblur = null;
    },
    // 编辑原文
    sourceEditor() {
      if (!this.sourceSid) {
        this.$message.closeAll();
        this.$message({
          message: "光标在在原文区内时才能编辑原文哦~",
          type: "warning",
        });
        return;
      }
      const that = this;
      let lefTag = this.sourceDomFun(this.sourceSid);
      if (this.isSourceEd) {
        this.outSourceEditor();
        return;
      }
      this.isSourceEd = true;
      lefTag.style.border = "1px solid";
      this.sourceEditorLefTag = lefTag;
      const oldInnerText = lefTag.innerText;
      lefTag.oninput = null;
      lefTag.onblur = function ($event) {
        that.isSourceEd = false;
        lefTag.style.border = "0px";
        if ($event.target.innerText.length < 1) {
          $event.target.innerHTML = "&nbsp;";
        }
        if (oldInnerText != $event.target.innerText) {
          that.updateSource($event.target);
        }
        $event.target.oninput = function ($event) {
          $event.target.innerText = that.myInnerText;
        };
        $event.target.onblur = null;
      };
    },
    // 操作置灰
    isFunBut(e, isShow = 1) {
      let node = this.getNode(e.target);
      this.isEditR = false;
      if (node.getAttribute("type") === "source") {
        this.typeShow = true;
        this.sid = node.getAttribute("sid");
        if (node.isContentEditable) {
          if (this.sourceSid != this.sid && this.isSourceEd) { // 修改原文：点击其他关闭修改原文
            this.outSourceEditor()
          }
          this.isEditR = true;
          this.sourceSid = this.sid;
          this.sentenceShow = true;
        }
        this.isLock = false
      } else {
        this.sentenceShow = false;
        this.typeShow = false;
        if (node.isContentEditable) {
          this.isEditR = true;
        }
        // 锁定重复句段
        if ((Number(node.getAttribute("rf")) > 0 || Number(node.getAttribute("rp")) > 0) && node.getAttribute("uk") === "0" && this.ifRepeatLock) {
          //区分进入口 项目&任务  项目经理或者当前译员
          if ((this.queryData.transStatus === 2 && (node.getAttribute("uid") === "0" || this.queryData.finish === 1)) ||
            (Number(node.getAttribute("uid")) === this.userInfo.id && this.ifSubmit)) {
            this.isLock = true
          } else {
            this.isLock = false
          }
        } else {
          this.isLock = false;
        }
      }
    },
    //model 1左右对照 2上下对照 3表格
    unlockSentenceBase(sourceTag, targetElm, model) {
      console.log(sourceTag, targetElm)
      let that = this;
      let sentId = targetElm.getAttribute("sid");
      this.catReq1Service("/api/v1/file/updateSentUnlockStatus", {
        transFileId: this.queryData.fileId,
        sid: sentId
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        //解锁
        sourceTag.setAttribute("contenteditable", that.contentEditableValue);
        sourceTag.setAttribute("editable", "true");
        sourceTag.setAttribute("uk", "1");
        if (model === 1) {
          sourceTag.style.color = that.editorNo;
        }
        sourceTag.style.outline = "none";
        sourceTag.removeAttribute("title")

        //增加监听
        sourceTag.oninput = function ($event) {
          if ($event.target.innerText !== that.myInnerText) {
            $event.target.innerText = that.myInnerText;
          }
        };
        sourceTag.onfocus = function ($event) {
          that.myInnerText = $event.target.innerText;
        };

        targetElm.setAttribute("uk", "1");
        targetElm.setAttribute("contenteditable", that.contentEditableValue);
        targetElm.style.color = that.editorNo;
        targetElm.style.outline = "none";
        targetElm.setAttribute("editable", "true");
        targetElm.removeAttribute("title")
        targetElm.onkeydown = function ($event) {
          $event.target.setAttribute('cf', 'true')
          that.enterKey($event);
        };
        targetElm.oninput = function ($event) {
          $event.target.setAttribute('cf', 'true')
          that.changeText($event.target, true);
        };
        targetElm.onblur = function ($event) {
          that.blurText($event.target);
        };
        targetElm.onfocus = function ($event) {
          that.onFocus($event.target);
        };
      });
    },
    // 复制原文到译文
    copySource() {
      let domList = this.$refs.redactBox.querySelectorAll(
        `span[sid='${this.sid}']`
      );
      domList[1].innerText = domList[0].innerText;
      this.changeText(domList[1]);
      this.sentenceShow = false;
    },
    //  右侧菜单开关
    startRigBox() {
      if (!this.RigBoxIf) {
        this.RigBoxIf = true;
        this.RigSwitchVal = "true";
        this.$nextTick(() => {
          this.$refs.redactBox.style.width = "calc(100% - 360px)";
          this.$refs.rigContantBox.style.width = "300px";
          this.$refs.rigContantBox.style.marginRight = "20px";
        });
      } else {
        this.RigBoxIf = false;
        this.RigSwitchVal = "false";
        this.$nextTick(() => {
          this.$refs.redactBox.style.width = "calc(100% - 40px)";
          this.$refs.rigContantBox.style.width = "0px";
          this.$refs.rigContantBox.style.marginRight = "0";
        });
      }
    },
    // 回车聚焦
    goFocus(dom, index) {
      if (dom[index].isContentEditable || !dom[index + 1]) {
        return dom[index];
      } else {
        return this.goFocus(dom, index + 1);
      }
    },
    // 设置样式
    setSpanStyle(tagList, cssAry) {
      for (let i = 0; i < tagList.length; i++) {
        for (let j = 0; j < cssAry.length; j++) {
          tagList[i].style[cssAry[j].s] = cssAry[j].c;
        }
      }
    },
    // 获取父级元素
    getNode(node) {
      if (!node.getAttribute("type") && node.nodeName === "SPAN") {
        return this.getNode(node.parentNode);
      } else {
        this.parentNode = node;
        return node;
      }
    },
    // 获取父级元素 解决 text-indent
    getPNode(node, sid) {
      if (!node) {
        return
      }
      if (node.nodeName === "P" || node.nodeName === "p") {
        let obj = node.style,
          val;
        Object.keys(obj).forEach(item => {
          if (item === 'textIndent') {
            val = obj[item];
            node.style.textIndent = "0px";
          }
        })
        if (val) {
          node.querySelector(`span[sid]`).style.textIndent = val;
        }
        return val;
      } else {
        return this.getPNode(node.parentNode, sid);
      }
    },
    // 查词搜索
    search(e) {
      this.$refs.editorOperation.search()
    },
    // 获取任务进度
    getTaskProgress() {
      let that = this;
      // if (this.queryData.progress !== undefined) {
      //   this.progress = this.queryData.progress;
      //   return;
      // }
      this.catReq1Service(
        "/api/v1/fileTask/get_task_progress", {
          fileId: this.queryData.fileId,
          taskType: that.queryData.taskType,
          taskId: this.queryData.taskId
        },
        "post",
        2
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        that.progress = response.result.progress;
      });
    },
    // 记忆库提示
    getmemory(innerText, type, isSentence) {
      let that = this;
      let sourcePar;
      // let sourceSent;
      let range = 0;
      try {
        range = window.getSelection().getRangeAt(0);
      } catch (e) {
        console.log(e)
      }
      sourcePar = type ? innerText.sourceSent : innerText;
      // if (isSentence && range.startOffset>8) {
      //   sourceSent = innerText.slice(0,range.startOffset)
      // }else{
      //   sourceSent = sourcePar
      // }
      let params = {
        sourceIndex: range.startOffset,
        sourcePar,
        fileId: this.queryData.fileId,
      };

      this.catReq1Service(
        "/api/v1/memory/findMemorySentSimilarSent",
        params,
        "post",
        2
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        that.memoryHintList = [];
        let data = response.result || [];
        if (data.length < 1) {
          return;
        }
        data.forEach((item) => {
          // if (item.similarPercent < 100) {
          that.memoryHintList.push(item);
          // }
        });
        that.$nextTick(() => {
          let memoryHint = document.getElementById("memoryHint");
          if (!memoryHint) {
            return;
          }
          let delAry = memoryHint.getElementsByClassName("del");
          let insertAry = memoryHint.getElementsByClassName("insert");
          delAry = Array.from(delAry);
          delAry.forEach((item) => {
            item.style.textDecoration = "line-through";
            item.style.color = "red";
          });
          insertAry = Array.from(insertAry);
          insertAry.forEach((item) => {
            item.style.color = "blue";
          });
        });
      });
    },
    // 添加术语弹窗
    async addTerm() {
      this.targetInput = this.targetInput.replace(
        /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
        ""
      );
      this.txt = "是否保存到项目术语库并替换所有未确认句段？";
      this.inputTxt = this.inputTxt.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      if (this.inputTxt === "" || this.targetInput === "") {
        this.$message.closeAll();
        this.$message({
          message: "添加的术语为空或对应的译文为空",
          type: "warning",
        });
        return;
      }
      if (process.env.VUE_APP_NAME !== "hospital") {
        let params = {
          sourceLang: this.queryData.sourceLang,
          targetLang: this.queryData.targetLang,
          fileId: this.queryData.fileId,
        };
        const response = await this.catReq1Service(
          "/api/v1/term/checkInterpretiveScheme",
          params
        ); // 判断当前领域的语言对是否走内部翻译（通用）
        if (!response.success) {
          return;
        }
        let flag = response.result.flag;
        if (flag) {
          this.termSentNumberHint();
        } else {
          this.addTermSent(0);
        }
      } else {
        this.termSentNumberHint();
      }
    },
    // 添加术语
    addTermSent(isReplace) {
      var that = this;
      isReplace ? (that.dialogVisible = true) : null;
      let params = {
        fileId: that.queryData.fileId,
        sourceSent: that.inputTxt,
        targetSent: that.targetInput,
        isReplace,
      };
      this.catReq1Service("/api/v1/termSent/addTermSent", params).then(function (
        response
      ) {
        that.dialogVisible = false;
        if (!response.success) {
          return;
        }
        let data = response.result;
        that.$nextTick(() => {
          if (data.length > 0) {
            data.forEach((item) => {
              let itemDom = that.$refs.redactBox.querySelectorAll(
                `span[sid='${item.id}']`
              )[1];
              itemDom ? (itemDom.innerText = item.targetSent) : null;
            });
          }
        });
        that.$message({
          message: isReplace ?
            "已替换所有未确认句段中的术语" : "术语已经添加到项目术语库",
          type: "success",
        });
        that.inputTxt = "";
        that.targetInput = "";
      });
    },
    // 添加术语弹窗保存键
    async messageIf() {
      if (this.mesBox) {
        this.mesBox = false;
        this.addTermSent(0);
      }
    },
    // 获取替换术语字数并显示术语弹窗
    async termSentNumberHint() {
      let params = {
        fileId: this.queryData.fileId,
        sourceSent: this.inputTxt,
        roleLevel: this.roleLevel,
      };
      const response = await this.catReq1Service(
        "/api/v1/termSent/termSentNumberHint",
        params
      ); // 获取替换术语字数
      if (!response.success) {
        return;
      }
      let data = response.result;
      let sentNumber = data.sentNumber;
      this.txt =
        data.roleLevel < 3 ?
        `是否将术语添加到项目术语库，</br>并替换本项目内所有未确认句段中的${
              data.sentNumber
            }个术语？` :
        `是否替换本任务所有未确认句段中的${data.sentNumber}个术语？`;
      if (sentNumber) {
        this.mesBox = true;
      } else {
        this.addTermSent(0);
      }
    },
    // 关闭弹窗
    onCancel() {
      this.mesBox = false;
    },
    // 确认添加术语替换
    empty() {
      this.mesBox = false;
      this.addTermSent(1);
    },
    // 监测文件
    monitorStatus() {
      let that = this;
      let params = {
        transFileIdList: [this.queryData.fileId],
        transProjectIdList: [],
      };
      this.catReq1Service("/api/v1/project/check_trans_status", params).then(
        function (response) {
          if (!response.success) {
            return;
          }
          let data = response.result.transFileRespVoList[0];
          that.isSplit = data.isSplit;
          if (that.queryData.project != 3) {
            (data.isSplit && !data.finish) ? that.ifSubmit = false: that.ifSubmit = true;
          }
        }
      );
    },
    // 任务状态监测
    checkTaskStatus() {
      let that = this;
      this.catReq1Service("/api/v1/fileTask/checkTaskStatus", {
        id: that.queryData.fileId,
        taskType: that.queryData.taskType,
        taskId: this.queryData.taskId
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        let data = response.result;
        if (that.queryData.taskType === 2) {
          if (data.taskFinish === 0 && data.fileTranslateFinish) {
            that.termSubmit = true;
            that.ifSubmit = true;
          } else {
            that.termSubmit = false;
            that.ifSubmit = false;
          }
          return;
        }
        if (data.taskFinish === 0) {
          that.termSubmit = true;
          that.ifSubmit = true;
        } else {
          that.termSubmit = false;
          that.ifSubmit = false;
        }
      });
    },
    rigBoxShow(data) {
      this.codeRigBox();
      switch (data) {
        case 2:
          this.isSeekBox == 2 ? (this.isSeekBox = false) : (this.isSeekBox = 2);
          this.search();
          break;
        case 3:
          if (!this.ifSubmit) {
            return
          }
          this.isSeekBox == 3 ? (this.isSeekBox = false) : (this.isSeekBox = 3);
          break;
        case 6:
          this.isSeekBox == 6 ? (this.isSeekBox = false) : (this.isSeekBox = 6);
          break;
        case "2_1":
          this.isSeekBox = 2;
          this.search();
          break;
        default:
          break;
      }
      let dom = document.getElementById("translation");
      let seekActive = dom.getElementsByClassName("seekActive");
      let len = seekActive.length;
      if (len > 0) {
        for (let i = len - 1; i > -1; i--) {
          if (i >= 0) {
            seekActive[i].style.background = "";
            seekActive[i].classList.remove("seekActive");
          }
        }
      }
      this.seekTxt = "";
      // this.seekShow();  // 清空查找内容
    },
    // 快捷键
    shortcutKey(e) {
      let that = this;
      e = e || window.event;
      let k = e.keyCode || e.which;
      switch (k) {
        case 70:
          if (e.ctrlKey) {
            // 查找替换
            e.returnValue = false;
            // that.codeRigBox();
            that.seekShow();
            event.preventDefault(e);
            return false;
          }
          break;
        case 66: // 添加术语
          if (e.ctrlKey) {
            e.returnValue = false;
            that.codeRigBox();
            that.rigBoxShow(3);
            event.preventDefault(e);
            return false;
          }
          break;
        case 77: // 右侧菜单显示
          if (e.ctrlKey) {
            e.returnValue = false;
            that.startRigBox();
            event.preventDefault(e);
            return false;
          }
          break;
        case 32: // 替换系统空格
          document.execCommand("insertHtml", false, "<font>&nbsp;</font>");
          e.returnValue = false;
          break;
      }
    },
    async setIsSeekBox(data) {
      if (!this.RigBoxIf) {
        this.startRigBox();
      }
      if (this.isSeekBox == 4) {
        this.isSeekBox = false;
        return
      }
      this.isSeekBox = data;
      //
    },
    // 添加术语
    rigAddTerm() {
      this.isSeekBox = 3;
      this.codeRigBox();
    },
    setPostilId(item, res) {
      let that = this;
      this.isAddPostil = false;

      function set(item, i) {
        let parentDom = item.parentNode;
        if (item.getAttribute("pid")) {
          let pDom = that.$refs.redactBox.querySelector(
            `div[pid='${item.getAttribute("pid")}']`
          );
          pDom.setAttribute("txt", i.comment);
          return;
        }
        item.style.width = "100%";
        item.setAttribute("pid", i.sentId);
        parentDom.style.position = "relative";
        parentDom.style.display = "block";
        parentDom.style.width = "100%";
        parentDom.style.boxSizing = "border-box";
        let strNode = document.createElement("div"); // 创建一个节点用来放拆分的上一部分
        strNode.className = "postilBut";
        strNode.setAttribute("pid", i.sentId);
        strNode.setAttribute("txt", i.comment);
        strNode.setAttribute("postilId", i.id);
        strNode.style.top = item.offsetTop + "px";
        strNode.onclick = function ($event, item) {
          let target = $event.target;
          if ((that.postilId === target.getAttribute("pid") && (that.isSeekBox == 5))) {
            that.isSeekBox = false;
            return
          }
          that.updatePostilTxt = target.getAttribute("txt");
          that.postilId = target.getAttribute("pid");
          let dom = that.$refs.redactBox.querySelector(
            `span[pid='${that.postilId}']`
          );
          that.isUpdatePostilBut = dom.isContentEditable;
          that.isSeekBox = 5;
          if (!that.RigBoxIf) {
            that.startRigBox();
          }
          that.postilTarget = {
            txt: dom.innerText,
            sid: that.postilId,
            butTag: target,
            tag: dom,
            id: target.getAttribute("postilId"),
          };
        };
        parentDom.appendChild(strNode);
      }
      if (res) {
        // 新增批注 修改
        set(item, res);
        return;
      }
      this.postilList.forEach((i) => {
        if (item.getAttribute("sid") == i.sentId) {
          set(item, i);
        }
      });
    },
    // 获取句子批注
    async queryBySentId(idList) {
      // this.isAddPostil = false;
      // this.isUpdatePostil = false;
      // this.isSeekBox == 5 || this.isSeekBox == 4 ? this.isSeekBox = '' : '';
      let list = [];
      // if (!this.ifSubmit) {
      //     return;
      // }
      const response = await this.catReq1Service(
        "/api/v1/comment/queryByTransFileId", {
          id: this.queryData.fileId,
        }
      );
      if (!response.success) {
        return;
      }
      const data = response.result;
      data.forEach((item) => {
        if (item.commentType == 3) {
          // this.isUpdatePostil = true;
          this.updatePostilTxt = item.comment;
          this.postilId = item.id;
          list.push(item);
        }
      });
      this.postilList = list;
      return list;
    },
    // 术语提示
    getTerm(innerText) {
      let that = this;
      let params = {
        sourceSent: innerText,
        companyCode: localStorage.myCompanyCode,
        sourceLang: that.queryData.sourceLang,
        targetLang: that.queryData.targetLang,
        fileId: that.queryData.fileId,
      };
      this.catReq1Service(
        "/api/v1/termSent/queryTransTermSentList",
        params,
        "post",
        2
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        that.termHintList = response.result || [];
      });
    },
    // 关闭右键菜单
    clearRightMenu() {
      if (this.rightMenuShow) {
        this.rightMenuShow = false;
      }
    },
    // 句子实时对照
    async sentenceContrast(lefTag, rigTag, callback) {
      if (!this.isEditorSentHighlight) {
        return;
      }
      let range = window.getSelection().getRangeAt(0);
      let location = range.startOffset;
      let modify = rigTag.innerText;
      let rSid = rigTag.parentElement.getAttribute('sid');
      if (rSid != null) {
        let preLocation = 0;
        //有编辑模式，父级才是
        for (let i = 0; i < rigTag.parentElement.children.length; i++) {
          let node = rigTag.parentElement.children[i]
          // console.log(node, rigTag, node === rigTag)
          if (node === rigTag) {
            break;
          }
          preLocation += node.innerText.length;
        }
        location += preLocation;
        modify = rigTag.parentElement.innerText
      } else if (rigTag.childNodes.length > 1) {
        let preLocation = 0;
        for (let i = 0; i < rigTag.childNodes.length; i++) {
          let node = rigTag.childNodes[i]
          if (node === rigTag) {
            break;
          }
          preLocation += node.innerText.length;
        }
        location += preLocation;
      }
      const params = {
        fileId: this.queryData.fileId,
        location: location,
        modify: modify,
        original: lefTag.innerText,
        sid: lefTag.getAttribute("sid"),
      };
      const res = await this.catReq1Service(
        "/api/v1/file/editorSentHighlight",
        params,
        "post",
        2
      );
      if (res.success) {
        this.contrastTag = lefTag;
        const data = res.result.highlight;
        this.contrastStatus = true;
        if (data[1] <= lefTag.innerText.length) {
          let str = lefTag.innerText.splice(data[1], "</font>");
          lefTag.innerHTML = str.splice(data[0], `<font id='fontContrast' color='${this.bCb? '#62b3ff':'blue'}'>`);
          if (callback && typeof callback === 'function') {
            callback.call(this, data[0], data[1])
          }
        }
      }
    },
    // 单词补全
    AutoCompleMixin(wordDom, src_sentence, nodeName) {
      let that = this;
      let range = window.getSelection().getRangeAt(0);
      let contextLeft;
      if (range.endContainer.data) {
        contextLeft = range.endContainer.data.slice(0, range.endOffset);
        this.contextRight = range.endContainer.data.slice(range.endOffset, -1);
      }
      let reg = /([^]+)\s([a-zA-Z]+)$/;
      let data = reg.exec(contextLeft);
      this.completion = data;
      // rigTag.classList.add("uiop")
      // this.css1('.uiop:after{content:\'修改一下\'}')
      // 获取x轴y轴
      let doc = event.target.ownerDocument || event.target.document;
      let win = doc.defaultView || doc.parentWindow;
      let pos = this.getSelectionCoords(win, nodeName);
      if (data === null) {
        return;
      }
      if (data.length > 2 && data[2].length > 2) {
        let params = {
          src_sentence,
          prefix: data[2],
          context_left: data[1],
          context_right: this.contextRight,
          K: 1,
          language: "zh2en",
        };
        this.casReqService("/suggestion", params, "post", 2).then((res) => {
          if (res.words.length > 0) {
            that.words = res.words;
          } else {
            return;
          }
          if (res.words[0] === data[2]) {
            return;
          }
          that.resWord = res.words[0];
          that.weew(pos.x, pos.y);
          wordDom.parentNode.onkeydown = function ($event) {
            that.completionKey(wordDom.parentNode, $event);
          };
        });
      }
    },
    weew(x, y) {
      this.isWordBox = true;
      this.$nextTick(() => {
        this.$refs.WordBox.style.top = y - 30 + "px";
        this.$refs.WordBox.style.left = x + "px";
      });
    },
    // 获取单词补全坐标
    getSelectionCoords(win, nodeName) {
      win = win || window;
      var doc = win.document;
      var sel = doc.selection,
        range,
        rects,
        rect;
      var x = 0,
        y = 0;
      if (sel) {
        if (sel.type != "Control") {
          range = sel.createRange();
          range.collapse(true);
          x = range.boundingLeft;
          y = range.boundingTop;
        }
      } else if (win.getSelection) {
        sel = win.getSelection();
        if (sel.rangeCount) {
          range = sel.getRangeAt(0).cloneRange();
          if (range.getClientRects) {
            range.collapse(true);
            rects = range.getClientRects();
            if (rects.length > 0) {
              rect = rects[0];
            }
            // 光标在行首时，rect为undefined
            if (rect) {
              x = rect.left;
              y = rect.top;
            }
          }
          // Fall back to inserting a temporary element
          if ((x == 0 && y == 0) || rect === undefined) {
            let node = doc.createElement(nodeName);
            if (node.getClientRects) {
              // Ensure node has dimensions and position by
              // adding a zero-width space character
              node.appendChild(doc.createTextNode("\u200b"));
              range.insertNode(node);
              rect = node.getClientRects()[0];
              x = rect.left;
              y = rect.top;
              let nodeParent = node.parentNode;
              nodeParent.removeChild(node);
              // Glue any broken text nodes back together
              nodeParent.normalize();
            }
          }
        }
      }
      return {
        x: x,
        y: y,
      };
    },
    // 单词补全的 快捷键 tab
    completionKey(wordDom, e) {
      let that = this;
      e = e || window.event || arguments[0];
      var k = e.keyCode || e.which;
      if (k === 39) {
        e.returnValue = false;
      }
      if (this.completion === null) {
        return;
      }
      let word = this.completion[2];
      let len = word.length;
      switch (k) {
        case 39:
          for (let i = 0; i < len; i++) {
            document.execCommand("delete");
          }
          document.execCommand("insertText", false, that.words[0]);
          this.isWordBox = false;
          wordDom.onkeydown = null;
          return false;
          break;
        default:
          this.isWordBox = false;
          wordDom.onkeydown = null;
          break;
      }
    },
    onSeekTxt2(data) {
      this.seekTxt2 = data;
    },
    onSeekTxt(data) {
      this.seekTxt = data;
    },
    onInputTxt(data) {
      this.inputTxt = data;
    },
    onTargetInput(data) {
      this.targetInput = data;
    },
    onUpdatePostilTxt(data) {
      this.updatePostilTxt = data;
    },
  },
};